import list from 'src/modules/apiKey/list/apiKeyListReducers';
import form from 'src/modules/apiKey/form/apiKeyFormReducers';
import view from 'src/modules/apiKey/view/apiKeyViewReducers';
import destroy from 'src/modules/apiKey/destroy/apiKeyDestroyReducers';
import importerReducer from 'src/modules/apiKey/importer/apiKeyImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
